import { currentAppEnvConfigs } from '@/configs/env'

export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url)
    return true
  } catch (_e) {
    return false
  }
}

/**
 * Add params to the current URL without refreshing the page
 * @param params - The params to add to the URL
 */
export function addParamWithoutRefresh(params: Record<string, any>) {
  const url = new URL(window.location.href)
  Object.entries(params).forEach(([name, value]) => {
    url.searchParams.set(name, value)
  })
  window.history.pushState({}, '', url.toString())
}

export const buildCoinIconUrlBySourceSlug = (source_slug: string) =>
  `https://${currentAppEnvConfigs.cdcStaticDomain}/token/icons/${source_slug}/color_icon.png`

export const buildFiatIconUrlBySourceSlug = (source_slug: string) =>
  `https://${currentAppEnvConfigs.backendHosts.priceStatic}/fiat/icons/${source_slug}/color_icon.png`
